;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';

import cx from 'classnames';

import FlipDeck from 'components/ui/FlipDeck';
import Link from 'components/ui/Link';
import ReCaptchaLegal from 'components/ui/ReCaptchaLegal';
import Spinner from 'components/ui/Spinner';
import SvgIcon from 'components/ui/SvgIcon';
import Text from 'components/ui/Text';

import useSubscribe from 'hooks/useSubscribe';
import { EMAIL_REGEX } from 'utils';
import { event } from 'utils/gtm';

import styles from './Newsletter.module.scss';

const slides = [
    {
        __typename: '',
        image: {
            title: 'Tillamook Classic Grilled Cheese',
            description: 'Tillamook Classic Grilled Cheese',
            url: 'https://images.ctfassets.net/j8tkpy1gjhi5/6EzWYwFgVRrOtXh4ANNRLe/3161673b3760c4a7dd4b153d15b5cb45/Tillamook_Classic_Grilled_Cheese-grid.png',
            width: 816,
            height: 816,
        },
        caption: 'Tillamook Classic Grilled Cheese',
    },
    {
        __typename: '',
        image: {
            title: 'Caprese Grilled Cheese Sandwich',
            description: 'Caprese Grilled Cheese Sandwich',
            url: 'https://images.ctfassets.net/j8tkpy1gjhi5/1O5fHE6fHXAr13E44FKf5j/44b6c42d753670513945290075ad2232/Caprese_Grilled_Cheese.png',
            width: 816,
            height: 816,
        },
        caption: 'Caprese Grilled Cheese Sandwich',
    },
    {
        __typename: '',
        image: {
            title: 'Chicken Marinara Mozzarella Sandwich',
            description: 'Chicken Marinara Mozzarella Sandwich',
            url: 'https://images.ctfassets.net/j8tkpy1gjhi5/73zAfVk1KCMvDn2wtornOz/bac1dacf957f214818decfbec27b30f5/Chicken-Marinara-Mozzarella-Sandwich.jpg',
            width: 816,
            height: 816,
        },
        caption: 'Chicken Marinara Mozzarella Sandwich',
    },
];

const Newsletter = () => {
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm();

    const { subscribe, isSubmitting, isSuccess, isError, isSubscribed } =
        useSubscribe('Recipes_Index_General_Messaging', true);

    useEffect(() => {
        if (isSuccess) {
            event('new_subscriber', {
                formLocation: 'block',
                source: 'Recipes_Index_General_Messaging',
            });
        }
    }, [isSuccess]);

    return (
        <div className={styles.root}>
            <div className={styles.inner}>
                <div className={styles.contentWrapper}>
                    <h1 className={styles.headline}>want more recipes?</h1>
                    <div className={styles.copyWrapper}>
                        <Text
                            as="p"
                            className={styles.description}
                            baseTheme="bodyMedium"
                            themes={{ large: 'bodyLarge' }}
                            fixWidows
                        >
                            We’re always cooking up new things. Sign up for
                            recipe emails and we’ll keep it fresh.
                        </Text>
                    </div>
                    <form
                        className={styles.form}
                        onSubmit={handleSubmit(data => {
                            delete data.terms;
                            subscribe(data);
                        })}
                    >
                        <div
                            className={cx(styles.inputLockup, {
                                [styles.inputSuccess]: isSuccess,
                            })}
                        >
                            <Text
                                className={styles.inputWrap}
                                baseTheme="bodyMedium"
                            >
                                {isSuccess ? (
                                    <p className={styles.input}>
                                        Successfully submitted!
                                    </p>
                                ) : (
                                    <input
                                        {...register('email_address', {
                                            required: true,
                                            pattern: EMAIL_REGEX,
                                        })}
                                        className={cx(styles.input, {
                                            [styles.inputError]:
                                                errors.email_address ||
                                                isSubscribed,
                                        })}
                                        type="email"
                                        autoComplete="email"
                                        placeholder={'Enter your email'}
                                    />
                                )}
                            </Text>
                            <div
                                className={cx(styles.submitButtonWrap, {
                                    [styles['submitButtonWrap__isLoading']]:
                                        isSubmitting,
                                    [styles['submitButtonWrap__isSuccess']]:
                                        isSuccess,
                                })}
                            >
                                <button
                                    type="submit"
                                    className={styles.submitButton}
                                >
                                    <span className="sr-only">Submit</span>
                                    <SvgIcon
                                        type="arrowRight"
                                        className={styles.submitArrow}
                                    />
                                </button>
                                <div className={styles.buttonSpinner}>
                                    <Spinner />
                                </div>
                            </div>
                        </div>
                        <div className={styles.reCaptchaLegal}>
                            <ReCaptchaLegal />
                        </div>
                        <Text baseTheme="bodySmall" className={styles.checkbox}>
                            <label
                                className={cx(styles.checkbox, {
                                    [styles['checkbox-error']]: errors.terms,
                                })}
                            >
                                I agree to receive emails for marketing
                                purposes. Read{' '}
                                <Link
                                    href="/privacy-policy"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Privacy Policy
                                </Link>
                                <input
                                    type="checkbox"
                                    {...register('terms', {
                                        required: true,
                                    })}
                                />
                                <span className={styles.checkmark} />
                            </label>
                        </Text>
                        <div className={styles.joinError}>
                            <Text
                                className={styles.joinErrorInner}
                                baseTheme="bodyXSmall"
                            >
                                {(errors.email_address || isError) &&
                                    'Email is invalid'}
                                {isSubscribed && (
                                    <>
                                        Oops, looks like you&rsquo;re already
                                        subscribed.
                                    </>
                                )}
                            </Text>
                        </div>
                    </form>
                </div>
                <div className={styles.deckWrapper}>
                    <FlipDeck slides={slides} isCreamHeavy />
                </div>
            </div>
        </div>
    );
};

export default Newsletter;
